import React, { Component, useState } from 'react'
import styled from 'styled-components'
import { MsalContext } from '@azure/msal-react'
import { loginRequest } from '../../auth365Config'
import { callMsGraph, callMsGraphPhoto } from '../../graph'
import { Button } from 'advenio-components'
import { COOKIE_DOMAIN } from '../../config'

const Icon = styled.img`
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-right: 10px;
    @media (max-width: 763px) {
      width: 15px;
      height: 15px;
    }
`
class ButtonMSAuth365 extends Component {
  static contextType = MsalContext

  constructor(props) {
    super(props)
    this.state = {
      responseLogin: null,
      graphData: null,
    }
  }
  loginAuth365 = () => {
    const {
      responseLogin,
      graphData,
    } = this.state

    // if (loginType === "popup")
    this.context.instance.loginPopup(loginRequest).then(response => this.setState({ responseLogin: response })).catch((e) => {
      console.log('ErrorloginPopup')
      console.log(e)
      this.logoutAuth365()
    })
    // } else if (loginType === "redirect") {
    //     instance.loginRedirect(loginRequest).catch(e => {
    //         console.log(e);
    //     });
    // }

    // if(responseLogin !== null && graphData === null){
    //   this.context.instance.acquireTokenSilent({
    //       ...loginRequest,
    //       account: accounts[0]
    //   }).then((response) => {
    //       callMsGraph(response.accessToken).then(response =>  this.setState({graphData:response}));
    //   }).catch(e => {
    //       console.log('ErrorAcquireTokenSilent')
    //       // instance.acquireTokenRedirect({
    //       //     ...loginRequest,
    //       // }).then((response) => {
    //       //     callMsGraph(response.accessToken).then(response => console.log(response))
    //       // }).catch(e => {
    //       //     console.log('acquireTokenRedirect')
    //       //     console.log(e)
    //       // })
    //       console.log(e)

    //   })
    // }
  }

  logoutAuth365 = (logoutType = null) => {
    // if (logoutType === "popup")
    this.context.instance.logoutPopup({
      postLogoutRedirectUri: '/',
      // mainWindowRedirectUri:"/login"
    })
    // } else if (logoutType === "redirect") {
    //     instance.logoutRedirect({
    //         postLogoutRedirectUri: "/",
    //     });
    // }
    // console.log(graphData)
  }
  // if (loginResponse !== null && graphData === null){
  getGraphData365 = () => {
    this.context.instance.acquireTokenSilent({
      ...loginRequest,
      account: this.context.accounts[0],
    }).then((response) => {
      callMsGraph(response.accessToken).then(response => this.setState({ graphData: response }))
      callMsGraphPhoto(response.accessToken)
        .then((response) => {
          let image = ''
          if (response !== null) {
            image = `data:image/jpeg;base64,${new Buffer(response, 'binary').toString('base64')}`
          }
          localStorage.setItem('image_profile', image)
        })
        .catch(error => error)
    }).catch((e) => {
      console.log('ErrorAcquireTokenSilent')
      // instance.acquireTokenRedirect({
      //     ...loginRequest,
      // }).then((response) => {
      //     callMsGraph(response.accessToken).then(response => console.log(response))
      // }).catch(e => {
      //     console.log('acquireTokenRedirect')
      //     console.log(e)
      // })
      console.log(e)
    })
  }
  render() {
    const {
      responseLogin,
      graphData,
    } = this.state
    const {
      loginError,
      auth: {
        authorized,
        fetching,
      },
      LoginApi,
    } = this.props

    if (responseLogin !== null && graphData === null) {
      this.getGraphData365()
    }

    if (graphData !== null && loginError === '' && authorized === null && !fetching) {
      // console.log(responseLogin.accessToken)
      LoginApi({ email: graphData.mail, method_auth: 'Microsoft', access_token: responseLogin.accessToken })
    }
    if (loginError === 'No tienes permisos para accesar a esta plataforma') {
      setTimeout(() => {
        window.location.reload()
      }, 2000)
    }

    return (
      <div>
        <Button onClick={this.loginAuth365} transparent addShadow large fullWidth>
          <Icon src="assets/microsoft.svg" />
          Login Microsoft
        </Button>
        {/* <Button onClick={this.logoutAuth365} Defualt fullWidth>Logout Microsoft</Button> */}
      </div>
    )
  }
}

export default ButtonMSAuth365




// WEBPACK FOOTER //
// ./src/Containers/Auth/ButtonMSAuth365.jsx